import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'cookie-warning',
    templateUrl: './cookie-warning.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf]
})
export class CookieWarningComponent implements OnInit {
  visible = false;
  constructor() { }

  ngOnInit() {
    if (localStorage.getItem('cookie.acceptance') !== 'true') {
      this.visible = true;
    }
  }

  accept() {
    localStorage.setItem('cookie.acceptance', 'true');
    this.visible = false;
  }
}
